import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  hydrateDeflowSession,
  isAuthenticatedFromStore,
} from "@/lib/browser-auth";
import { isStandaloneBrowser } from "@/lib/runtime";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    if (!isStandaloneBrowser()) {
      throw redirect({ to: "/plugin/figma", replace: true });
    }

    await hydrateDeflowSession();
    throw redirect({
      to: isAuthenticatedFromStore() ? "/dashboard" : "/sign-in",
      replace: true,
    });
  },
});
